import { PublishedPlanShowView } from '@/views/anonymous/plans';

export default [
  {
    path: '/plans/:planIdentifier',
    name: 'app_plan_published_show',
    meta: { title: 'Published Plan', requiresAuthentication: false, redirectAuthenticatedUsers: false },
    component: PublishedPlanShowView,
  },
];
